export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const API_KEY = '7e897684-a060-4223-b072-458a47fcd6cc';
export const REQUEST_TIMEOUT_SEC = 10;
export const RESULTS_PER_PAGE = 10;
export const MODAL_CLOSE_SEC = 2.5;

////////////////////////////////////////
// https://forkify-api.herokuapp.com/v2
